import { i18nMark } from 'lingui-react';

const messages = {
  validating: i18nMark('Validating...'),
};

export default messages;



// WEBPACK FOOTER //
// ./features/authentication/LoginValidation/messages.js